module.exports = __webpack_public_path__ + "static/img/120004.204958e8.png";